import { Injectable, signal } from '@angular/core';

export type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private static readonly STORAGE_KEY = 'bycom-bandi-theme';
  private readonly themeSignal = signal<Theme>(this.loadTheme());

  constructor() {
    this.applyTheme(this.themeSignal());
  }

  get currentTheme() {
    return this.themeSignal;
  }

  isDark(): boolean {
    return this.themeSignal() === 'dark';
  }

  toggleTheme(): void {
    const next: Theme = this.themeSignal() === 'light' ? 'dark' : 'light';
    this.themeSignal.set(next);
    this.applyTheme(next);
    localStorage.setItem(ThemeService.STORAGE_KEY, next);
  }

  private loadTheme(): Theme {
    const stored = localStorage.getItem(ThemeService.STORAGE_KEY);
    return stored === 'dark' ? 'dark' : 'light';
  }

  private applyTheme(theme: Theme): void {
    if (theme === 'dark') {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
  }
}
